import { useState } from "react";
import Select from "react-select";
import { Button, Container, Label, Row, Table } from "reactstrap";
import { generateBreadcrumb } from "../../../../../Components/BreadCrum/BreadCrum";
import {
  handleDownloadRoleMembers,
  setCurrentPage,
  useMembersByRole,
  useRoleOptions,
} from "./MemberRoleMethods";
import CustomPagination from "../../../../../Components/Pagination/Pagination";
import { useNavigate, useParams } from "react-router-dom";
import { usePermission } from "../../../../../Components/Permissions/Admin/AdminPermission";

const MemberRoleReport = () => {
  const { currentPage = 1 } = useParams();
  const navigate = useNavigate();
  const { checkPermission } = usePermission();
  const roleOptions = useRoleOptions();
  const [selectedRole, setSelectedRole] = useState<any>();
  const roleId = selectedRole?.value || "null";
  const { data: roleData } = useMembersByRole(roleId, currentPage);

  let breadcrumbItems;
  const userRole = localStorage.getItem("ROLE");
  if (userRole === "admin") {
    breadcrumbItems = [
      { label: "Reports", link: "/admin/reports" },
      {
        label: "Members Role Report",
        link: "/admin/memberrole-report/1",
      },
    ];
  }
  else if (userRole === "member") {
    breadcrumbItems = [
      { label: "Reports", link: "/member/reports" },
      {
        label: "Members Role Report",
        link: "/member/memberrole-report/1",
      },
    ];
  }

  const breadcrumb = generateBreadcrumb(breadcrumbItems);

  const handleRoleChange = (selectedOption: any) => {
    setSelectedRole(selectedOption);
  };

  const handleDownloadClick = () => {
    const roleId = selectedRole ? selectedRole.value : null;
    handleDownloadRoleMembers(roleId, parseInt(currentPage.toString(), 10));
  };

  return (
    <section>
      <div className="content-outer-wrap">
        <Container>
          <div className="breadcrumb-wrap">{breadcrumb}</div>
          <div className="search-bar-full-wrap">
            <div className="select-wrap-spacing">
              <Select
                placeholder="Select Role"
                options={roleOptions}
                name="role"
                isSearchable={true}
                isClearable
                value={selectedRole}
                onChange={handleRoleChange}
              />
            </div>
            <div className="right-side-wrap">
            {checkPermission("reports:write") ? (
              <div className="button-wrap">
                  <Button
                    color="primary"
                    className="sm"
                    onClick={handleDownloadClick}
                  >
                    <i className="icon xl icon-download-white"></i>Download
                  </Button>
                </div>
              ): null}

              <Button
                color="primary"
                className="sm"
                outline
                onClick={() => {
                  setSelectedRole(null);
                  setCurrentPage(navigate, 1);
                }}
              >
                Reset
              </Button>
            </div>
          </div>
          <div className="content-list-outer-wrap">
            <Container>
              <Row className="gy-4">
                <div className="table-outer-wrap">
                  <div className="table-head-outer">
                    <div className="table-heading">
                      <h6>Members Role Report</h6>
                    </div>
                    <div className="table-outer">
                      <Table>
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>PEN NO</th>
                            <th>District</th>
                            <th>Block</th>
                            <th>Role</th>
                          </tr>
                        </thead>
                        <tbody>
                          {roleData?.data?.items?.map((item: any, i: number) => {
                            const currentIndex =
                              (roleData?.data?.meta?.currentPage - 1) *
                                roleData?.data?.meta?.itemsPerPage +
                              i +
                              1;
                            return (
                              <tr>
                                <td>{currentIndex}</td>
                                <td>{item?.user_first_name}</td>
                                <td>{item?.member_pen_no}</td>
                                <td>{item?.district_name}</td>
                                <td>{item?.block_name ?? '—'}</td>
                                <td>{item?.role_name}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </Row>
            </Container>
          </div>
        </Container>
        {roleData?.data?.meta?.totalItems !== 0 && (
          <div className="pagination">
            <CustomPagination
              totalItems={roleData?.data?.meta?.totalItems}
              itemsPerPage={roleData?.data?.meta?.itemsPerPage}
              activePage={roleData?.data?.meta?.currentPage}
              setCurrentPage={(pageNo: string) =>
                setCurrentPage(navigate, pageNo)
              }
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default MemberRoleReport;
